import { SadmEntityResponse } from '@pixacare/dtos';
import { StoreSadmEntity } from '../models/store-sadm-entity';

export const toStoreSadmEntity = (sadmEntity: SadmEntityResponse): StoreSadmEntity => {
  const sequenceIds = sadmEntity.sequences?.map((sequence) => sequence.sequenceInstance.id) ?? [];
  const newSadmEntity = { ...sadmEntity };
  delete newSadmEntity.sequences;
  delete newSadmEntity.createdByInstance;
  delete newSadmEntity.sadmClient;

  return {
    ...newSadmEntity,
    sequenceIds,
  };
};
